// extracted by mini-css-extract-plugin
module.exports = {"gradient":"__gradient__b6wxw","gradientText":"__gradientText__G5_G6","scrollbar":"__scrollbar__KBqeG"};